import { AuthenticationSngpcData } from '../interfaces/authentication';
import { SNGPCState } from '../store/sngpc/types';

import api from './api';
import { SngpcRegister } from '../interfaces/sngpc';

interface ResponseApiCreatedUser {
  data: {
    cadastrado: boolean;
  };
}

export const create = async (data: SngpcRegister): Promise<ResponseApiCreatedUser> => {
  const response = await api.post('/sngpc/cadastro', data);

  return response.data.data;
};

export const fetchCompanies = async (data: AuthenticationSngpcData): Promise<SNGPCState> => {
  const response = await api.post(
    '/sngpc/empresas',
    Object.assign(data, {
      resourceType: 'SNGPCEmpresasPayload',
    }),
  );

  return response.data.data;
};
